import React from "react";
import { Input } from "@revvsales/components";
import { RevvForm } from "../../../../commonComponents";

import {
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "../../DynamicField/DynamicFieldComponents/CustomFieldRulesMap";

export default class CheckboxFormMode extends React.Component {
  _handleOnChange = (event, i, values, handleChangeInList) => {
    handleChangeInList(event, i);
    const defaultData = [];
    for (let v = 0; v < values.default.length; v += 1) {
      if (
        values.default[v] === true ||
        values.default[v] === values.options[v]
      ) {
        defaultData.push(values.options[v]);
      }
    }
    const { id } = this.props.initialProps;
    setTimeout(
      () => this.props._updateField(id, defaultData),
      this._checkFilled(defaultData),
      this.props._updateDynamicFieldsInDoc(id, defaultData, defaultData.join()),
      100,
    );
  };

  getInitialValues = () => {
    const { meta, value } = this.props.initialProps;
    const copyOfData = [];
    for (let b = 0; b < meta.options.length; b += 1) {
      copyOfData.push("");
    }

    if (value) {
      for (let b = 0; b < meta.options.length; b += 1) {
        for (let h = 0; h < value.length; h += 1) {
          if (meta.options[b] === value[h]) {
            copyOfData[b] = value[h];
          }
        }
      }
    }
    const data = {
      options: JSON.parse(JSON.stringify(this.props.initialProps.meta.options)),
      default: copyOfData,
    };
    return data;
  };

  _checkFilled(defaultData) {
    if (defaultData.length >= 1) {
      this.props.filledStatus(true);
    } else {
      this.props.filledStatus(false);
    }
  }

  render() {
    const { id /* docIsLocked */ } = this.props.initialProps;
    return (
      <React.Fragment>
        <RevvForm
          revvFormId={id}
          initialFormValue={this.getInitialValues()}
          customFieldName="CHECKBOX"
          customFieldComponentRules={CustomFieldComponentRules}
          customFieldComponentMessages={CustomFieldComponentMessages}
          render={formProps => {
            const { handleChangeInList, values } = formProps;
            return values.options.map((opt, i) => (
              <React.Fragment>
                <span className="checkboxleftmar">
                  <Input
                    name="default"
                    type="checkbox"
                    data-test="input-revv-inp-checkbox-or-radio"
                    checked={values.default[i]}
                    disabled={this.props.isLocked}
                    onChange={event =>
                      this._handleOnChange(event, i, values, handleChangeInList)
                    }
                  />
                  <span className="dynamicfield-checkboxinputlabel dynamicfield-inputlabel-checkbox">
                    {opt}
                  </span>
                </span>
              </React.Fragment>
            ));
          }}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormModeComponents/CheckboxFormMode.js